import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { GetDeliveryMomentsResponse, OrderTypes } from '@next/core-lib/cart';
import { AgrEnvironment, EnvironmentInjector } from '@next/core-lib/environment';
import { Observable } from 'rxjs';

import { GetMultipleProductDeliveryDatesWith0FlexibilityResponse } from '../models/product-delivery-moment.models';

@Injectable({
  providedIn: 'root',
})
export class ProductDeliveryMomentApiService {
  protected baseUrl = `${this.env.APIM_BASE_URL}/cart-v2-service`;

  constructor(
    protected http: HttpClient,
    @Inject(EnvironmentInjector) private readonly env: AgrEnvironment,
  ) {}

  public getDeliveryMoments(skuId: number, orderType?: OrderTypes, flexibility?: number): Observable<GetDeliveryMomentsResponse> {
    let params = new HttpParams().set('ordertype', orderType ?? OrderTypes.salesOrder);

    if (flexibility !== undefined) {
      params = params.set('flexibility', flexibility);
    }

    return this.http.get<GetDeliveryMomentsResponse>(`${this.baseUrl}/delivery-moment/${skuId}`, {
      params,
    });
  }

  public getMultipleSkuDeliveryMoments(skuIds: number[], orderType?: OrderTypes): Observable<GetMultipleProductDeliveryDatesWith0FlexibilityResponse> {
    let params = new HttpParams().set('ordertype', orderType ?? OrderTypes.salesOrder);

    skuIds.forEach((skuId) => {
      params = params.append('skuIds', skuId.toString());
    });

    return this.http.get<GetMultipleProductDeliveryDatesWith0FlexibilityResponse>(`${this.baseUrl}/delivery-moment/SkuIds`, {
      params: params,
    });
  }
}
